import { Icon } from "@iconify/react";

const MaintenancePrompt = () => {
    return (
        <div className="flex flex-row gap-2 items-center justify-center w-full text-center text-font-secondary bg-bgSecondary shadow-neo-card p-3 rounded-lg">
            <Icon icon="wpf:maintenance" className="text-xl text-error" />
            <p className="text-lg">
                This page is currently under maintenance and will be updated in the next deployment. 
                Please check back soon for new features and improvements.
            </p>
        </div>
    );
};

const InfoPrompt = ({description, icon}) => {
    return (
        <div className="flex flex-row gap-2 items-center justify-center w-full text-center text-font-secondary bg-bgSecondary shadow-neo-card p-3 rounded-lg">
            <Icon icon={icon} className="text-xl text-orange-500" />
            <p className="text-lg">{description}</p>
        </div>
    );
};

export { MaintenancePrompt, InfoPrompt };